import {html, LitElement} from 'lit';
import {customElement, property, queryAssignedElements} from 'lit/decorators.js';

import styles, {searchTipStyle} from './searchbartool.styles';

@customElement('ui-searchbartool')
export class SearchBarTool extends LitElement {
  static readonly styles = [styles];

  @property({}) baseURL: string;
  @queryAssignedElements({selector: 'ui-searchtip'}) tips: HTMLElement[];

  slotContentChangeHandler() {
    this.tips.forEach(tip => {
      tip.addEventListener('click', e => {
        const target = e.target as Tip;
        if (target.textContent) {
          this.setupToplinksListeners(target.textContent);
        }
      });
    });
  }

  render() {
    return html`
      <slot @slotchange="${this.slotContentChangeHandler}"></slot>`;
  }

  /**
   * Setup event listeners for each toplink DOM node.
   * @param {string} search the text to search
   */
  setupToplinksListeners(search: string) {
    const decodeURL = atob(this.baseURL);
    window.open(decodeURL + search);
  }
}

@customElement('ui-searchtip')
export class Tip extends LitElement {
  static readonly styles = [searchTipStyle];

  render() {
    return html`
      <slot></slot>`;
  }
}
